import { Ambulance, MedicalEarPhone, Pharmecy } from '../../../Assets/SVGS'
import Header from '../../common/Header/Header'
import Icon from '../../common/Icon/Icon'
import ThreeCards from '../../sections/ThreeCards/ThreeCards'
import { useTranslation } from 'react-i18next'
import './One.css'
function One(){
  const { t } = useTranslation();
  return(
    <div className="one-container container">
      <div className="one-content content">
        <div className="threeCards">
          <ThreeCards/>
          <Header header={t('readyToHelp')} desc={t('readyToHelpDesc')}/>
        </div>
        <div className="cards">
          <div className="card">
            <Icon icon={<Ambulance width="40px"/>}/>
            <h3>{t('emergencyCare')}</h3>
            <p>{t('emergencyCareDesc')}</p>
          </div>
          <div className="card">
            <Icon icon={<Pharmecy width="40px"/>}/>
            <h3>{t('inHousePharmacy')}</h3>
            <p>{t('inHousePharmacyDesc')}</p>
          </div>
          <div className="card">
            <Icon icon={<MedicalEarPhone width="40px"/>}/>
            <h3>{t('support247')}</h3>
            <p>{t('support247Desc')}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
export default One